var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PageTitleBar", {
        attrs: { pois: _vm.pois },
        on: { selectedPoi: _vm.poiSelectedInSearch }
      }),
      _vm._v(" "),
      _c("MapWithMarkers", {
        ref: "map",
        attrs: {
          mapId: _vm.mapId,
          accessToken: _vm.accessToken,
          mapStyle: _vm.mapStyle,
          mapOptions: _vm.mapOptions,
          pois: _vm.poisWithEdit,
          visiblePathPois: [_vm.selectedPoi].filter(e => !!e),
          dateFrom: _vm.dateFrom,
          dateTo: _vm.dateTo,
          dateCurrent: _vm.dateCurrent
        },
        on: {
          "update:mapStyle": function($event) {
            _vm.mapStyle = $event
          },
          "update:map-style": function($event) {
            _vm.mapStyle = $event
          },
          poiClicked: _vm.onPoIClicked,
          poiEdit: _vm.onEditItem,
          poiDelete: _vm.onDeleteItem,
          "update:dateFrom": function($event) {
            _vm.dateFrom = $event
          },
          "update:dateTo": function($event) {
            _vm.dateTo = $event
          },
          "update:dateCurrent": function($event) {
            _vm.dateCurrent = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.selectedPoi
        ? _c("MarkerDetails", {
            attrs: { poi: _vm.selectedPoi, edit: _vm.selectedPoiEdit }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }